import React from 'react';
import PT from 'prop-types';
import classNames from 'classnames';
import classes from './matchupCell.css';

const MatchUpCell = ({ rating, day, country, children }) => {
  const cellClass = classNames({
    good: rating === 'good',
    bad: rating === 'bad',
    monday: day === 'Monday',
    thursday: day === 'Thursday',
    saturday: day === 'Saturday',
    bye: day === 'bye',
    eng: country === 'ENG',
    mex: country === 'MEX',
    deu: country === 'DEU',
    [classes.matchup]: true,
  });
  return <div className={cellClass}>{children}</div>;
};

MatchUpCell.propTypes = {
  rating: PT.string,
  children: PT.oneOfType([PT.string, PT.number]),
};

MatchUpCell.defaultProps = {
  rating: 'neutral',
  children: '',
  day: '',
  country: '',
};

export default MatchUpCell;



// WEBPACK FOOTER //
// ./src/app/components/DataTable/StatCells/MatchupCell.js